import React from 'react'
import BulletPoint from 'scenes/Dashboard/components/BulletPoint'
import { DigitalPresence } from 'scenes/Dashboard/data/digitalPresences/types'

import { createStyles, List, Theme, Typography } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

type AttachmentsProps = WithStyles<typeof styles> & { attachments: DigitalPresence[] }

function Attachments({ attachments, classes }: AttachmentsProps) {
  if (attachments.length === 0) {
    return null
  }

  return (
    <section className={classes.container}>
      <Typography variant="subtitle1">Documents</Typography>

      <List dense>
        {attachments.map((attachment, index) => {
          if (typeof attachment.value !== 'string') {
            return
          }

          return (
            <BulletPoint
              key={index}
              item={
                <Typography variant="body2">
                  <a href={attachment.value} target="_blank" rel="noopener noreferrer">
                    {attachment.label}
                  </a>
                </Typography>
              }
            />
          )
        })}
      </List>
    </section>
  )
}

const styles = ({ spacing }: Theme) =>
  createStyles({
    container: {
      marginBottom: spacing(2),
      marginTop: spacing(2),
    },
  })

export default withStyles(styles)(Attachments)
